import { useLocalSearchParams, useRouter } from "expo-router";
import { useEffect } from "react";
import { VStack } from "@/components/ui/vstack";
import {
  Button,
  ButtonIcon,
  ButtonSpinner,
  ButtonText,
} from "@/components/ui/button";
import { TabletSmartphone } from "lucide-react-native";
import { HStack } from "@/components/ui/hstack";
import { Text } from "@/components/ui/text";
import { Pressable } from "@/components/ui/pressable";
import { useWebToAppRedirect } from "@/utils/use.redirect.to.store";

export default function LogoutCallback() {
  const router = useRouter();
  const { to } = useLocalSearchParams<{ to: string }>();
  const { appPending, openApp } = useWebToAppRedirect();

  useEffect(() => {
    openApp(to, false);
  }, []);

  return (
    <VStack className="gap-6">
      <Button onPress={() => openApp(to, true)} isDisabled={appPending}>
        <ButtonIcon
          as={TabletSmartphone}
          size={20}
          className="text-typography-0"
        />
        <ButtonText>Open in App</ButtonText>
        {appPending && <ButtonSpinner />}
      </Button>
      <HStack space="sm" className="self-center">
        <Text size="md">Don't have an App?</Text>
        <Pressable
          onPress={() => {
            router.replace(to as any);
          }}
        >
          <Text
            size="md"
            className="font-medium text-primary-700 group-hover/link:text-primary-600  group-hover/pressed:text-primary-700"
          >
            Continue in browser
          </Text>
        </Pressable>
      </HStack>
    </VStack>
  );
}
